import React, { useEffect } from "react";
import Loader from "../components/loader";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("logged-in-as")) {
      if (localStorage.getItem("logged-in-as") === "client") {
        navigate(`/client`);
      } else if (localStorage.getItem("logged-in-as") === "admin") {
        navigate(`/admin`);
      }
    } else {
      navigate(`/client-login`);
    }
  }, []);

  return (
    <div>
      <Loader />
    </div>
  );
};

export default Home;
